<template>
  <div :class="boxClass">
    <h2 class="title">
      <div @click.prevent="toggleVisibility">
        {{ title }}
        <i :class="chevronClass"></i>
      </div>
    </h2>
    <div v-if="!isCollapsed" class="body text-content box-content">
      <div v-html="content"></div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      default: null
    },
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isCollapsed: false
    };
  },
  computed: {
    boxClass() {
      return ['info-box', 'box'];
    },
    chevronClass() {
      return null;
    }
  }
};
</script>

<style>
.box {
  margin-bottom: 20px;
  padding-left: 15px;
  padding-right: 15px;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.box .title {
  margin: 0;
  padding: 15px 0;
  letter-spacing: -0.02em;
}

.box .chevron {
  float: right;
  top: inherit !important;
  font-size: 0.8em;
}

.box .box-content {
  padding: 0 0 20px;
}
</style>
